import { Outlet } from 'react-router';

import { MAIN_CONTENT_ID } from '~/components/App/AppContents/constants';

/**
 * Layout route for routes that are reachable without authentication —
 * the login / activation / password flows plus a handful of pages that
 * are openable from email links (ticket email actions, external document
 * viewer, etc.). Deliberately a minimal shell with none of the logged-in
 * chrome (navbar, upload panel, auth modal, page padding).
 *
 * No auth guard here: these pages must work in any auth state. Routes
 * that should redirect away when the user is already authenticated do
 * that themselves (e.g. the Login page).
 */
export function LoggedOutLayout() {
  return (
    <main id={MAIN_CONTENT_ID}>
      <Outlet />
    </main>
  );
}
